import { Artist } from "../../types/response/ISearchArtistResponse";
import baseUrl from "../../utils/baseUrl";
import getToken from "../../utils/getToken";

export async function searchAllArtist() : Promise<Artist[]> {
  const response = await fetch(`${baseUrl()}/api/v1/artists/all`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getToken()}`,
    },
  });
  const data = await response.json();
  const allArtists : Artist[] = data.artists;
  
  return allArtists;
}

